import { PublicKey } from "@solana/web3.js";

export function deriveTokenVault(
  staking: PublicKey,
  programId: PublicKey,
): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("staking_vault"), staking.toBuffer()],
    programId,
  )[0];
}

export function deriveStakingAuthority(programId: PublicKey): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("staking_authority")],
    programId,
  )[0];
}

export function deriveEscrow(
  staking: PublicKey,
  owner: PublicKey,
  programId: PublicKey,
): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("escrow"), staking.toBuffer(), owner.toBuffer()],
    programId,
  )[0];
}

export function deriveEventAuthority(programId: PublicKey): PublicKey {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("__event_authority")],
    programId,
  )[0];
}
